<template>
<section>
  <div class="header">
    <div class="header_left">
      产融服务平台管理后台
    </div>
    <div class="header_right">
    <!-- title="消息：" -->
      <el-popover
        ref="popoverRef"
        placement="top-start"
        width="340"
        trigger="hover">
        <div slot="reference" class="bells">
        <el-badge :value="messages.count" class="item" :hidden="messages.count !== 0?false:true">
            <i :class="['el-icon-bell',{'helpTips':isReload}]"></i>
        </el-badge>
        </div>
        <div class="members">
          <el-row v-if="messages.stationNewsBackstageVo && messages.stationNewsBackstageVo.length !== 0">
              <el-col :span="12" v-for="(item,idx) in messages.stationNewsBackstageVo" :key="idx">
                <div class="member" @click="goUrl(item)">{{item.title}}<span>({{item.number}})</span></div>
              </el-col>
            </el-row>
            <el-empty description="暂无消息" v-else></el-empty>
        </div>
      </el-popover>
      <el-dropdown class="avatar_container" trigger="click"  @command="handleCommand">
        <div class="avatar_wrapper">
          <el-avatar src="" class="user_avatar" />
          <div class="user_name">{{ username }}</div>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">个人资料</el-dropdown-item>
            <el-dropdown-item command="2">修改密码</el-dropdown-item>
            <el-dropdown-item command="3">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
  <!-- 个人资料弹出层 -->
        <el-dialog
            title="个人资料"
            :visible.sync="dialogInfo"
            width="30%">
            <div class="basic">
                <div class="child">
                    <div class="name">姓名：</div>
                    <div class="content">{{userInfo.realName||'--'}}</div>
                </div>
                <div class="child">
                    <div class="name">账号：</div>
                    <div class="content">{{userInfo.username||'--'}}</div>
                </div>
                <div class="child" v-if="userInfo.sysRoleVoList&&userInfo.sysRoleVoList.length>0">
                    <div class="name">角色：</div>
                    <div class="content">
						<span
							v-for="(i,index) in userInfo.sysRoleVoList"
							:key="index"
							v-if="userInfo.sysRoleVoList.length==1"
						>{{i.roleName||'--'}}</span>
						<span
							v-for="(i,index) in userInfo.sysRoleVoList"
							:key="index"
							v-if="userInfo.sysRoleVoList.length>1"
						>{{i.roleName||'--'}}、</span>
					</div>
                </div>
            </div>
        </el-dialog>
        <!-- 修改密码弹出层 -->
        <el-dialog
            title="修改密码"
            :visible.sync="dialogPassword"
            width="30%"
            :close-on-click-modal="false">
            <div class="forms" v-if="dialogPassword">
                <div class="child">
                    <div class="name"><span>*</span>原密码：</div>
                    <div><el-input v-model="sendInfo.name1"></el-input></div>
                </div>
                <div class="error" v-if="errors['sendInfo.name1']">错误提示：{{errors['sendInfo.name1']}}</div>
                <div class="child">
                    <div class="name"><span>*</span>新密码：</div>
                    <div><el-input v-model="sendInfo.name2"></el-input></div>
                </div>
                <div class="hint">由字母、数字、字符组成，6-20位，区分大小写</div>
                <div class="error" v-if="errors['sendInfo.name2']">错误提示：{{errors['sendInfo.name2']}}</div>
                <div class="child">
                    <div class="name"><span>*</span>重新输入密码：</div>
                    <div><el-input v-model="sendInfo.name3"></el-input></div>
                </div>
                <div class="error" v-if="errors['sendInfo.name3']">错误提示：{{errors['sendInfo.name3']}}</div>
                <div class="doubleBtn">
                    <el-button type="primary" @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submit">保存</el-button>
                </div>
            </div>
        </el-dialog>
  </section>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      searchKey: void 0,
      home: process.env.VUE_APP_BASE_URL || void 0,
      loginUrl: process.env.VUE_APP_AUTH_URL,
      userInfo:JSON.parse(window.localStorage.getItem('userInfo'))||{},
            dialogInfo:false,//个人资料弹出层
            dialogPassword:false,//修改密码弹出层
            sendInfo:{//提交密码的表单信息
                name1:'',//原密码
                name2:'',//新密码
                name3:'',//重新输入密码
            },
            messages:{
              count: 0,
              stationNewsBackstageVo:[]
            },
            isReload:false,
            timer:void 0, // 计时器
            isStop:true
    }
  },
  computed: {
    username(){
            return this.$store.state.user.username
        },
        token(){
          return this.$store.state.user.token
        }
  },
 
  created(){
    if(this.$router.history.pending.path !== '/login' && this.token)
    {
    this.getMessage()
    this.createSetInterval()
    }
  },
  // 离开页面销毁轮询器
  destroyed() {
    this.stopSetInterval()
  },
  methods: {
    //点击设置选项
        handleCommand:function(command){
            switch(command){
                case '1':
                    // this.dialogInfo=true;
                    this.$router.push('/personal/center');
                    break;
                case '2':
                    // this.isShow()
                    this.$router.push('/personal/password');
                    break;
                case '3':
                    this.$store.commit({
                        type:'user/loginOut'
                    })
                    this.$router.push('/login');
                    break;
            }
        },
        async getMessage(){
          const {code,data,msg} = await this.$axiosc.get('/backstage/station/news/backstageList')
          if(code === 200) {
            this.messages = data || {
              stationNewsBackstageVo:[],
              count: 0
            }
          }
          
        },
        goUrl({path,number}){
          const that = this
          that.$refs.popoverRef.doClose();
          that.$router.push({path:path})      
          // setTimeout(() => {
          //   that.messages.count = that.messages.count - number
          // }, 200);
          setTimeout(() => {
              that.getMessage()
          }, 1000);
        },
        // 开启轮询  如果存在则先销毁定时器后重新开启
        createSetInterval() {
          const that = this
          that.stopSetInterval()
          that.timer = setInterval(() => {
            that.getMessage()
          }, 1000 * 60)
        },
        // 关闭轮询
        stopSetInterval() {
          const that = this
          if (that.timer) {
            clearInterval(that.timer)
            that.timer = null
            that.isReload = false
          }
        }
  },
 watch: {
   'messages.count': {
       immediate: true, // 第一次的数据，也要当做是一种变化
       // 处理函数（不能修改名字） handler('新的值'，'旧的值')
       handler(val) {
           if(val)this.isReload = true
            else this.isReload = false
       },
   },
	"$route": {
       immediate: true, // 第一次的数据，也要当做是一种变化
       // 处理函数（不能修改名字） handler('新的值'，'旧的值')
       handler(to,from, next) {
           // 执行代码部分
           if(to.path === '/login') {
             this.isStop = true
             this.stopSetInterval()
            }
           else this.isStop = false
       },
   },
   token: {
       immediate: true, // 第一次的数据，也要当做是一种变化
       // 处理函数（不能修改名字） handler('新的值'，'旧的值')
       handler(val, old) {
           // 执行代码部分
           if(val && val !== old){
             this.getMessage()
             this.createSetInterval()
           }
       },
   },
}


}
</script>
  <style lang="scss" scoped>
  .header{
    line-height: 64px;
    height:64px;
    background: $primary;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:0 24px 0 18px;
    &_left{
      color:#fff;
      font-size: 20px;
      font-weight: 500;
      display: flex;
      align-items: center;
      img{
        width:260px;
        height: 50px;
        margin-right:15px;
      }
    }
    &_right{
      display: flex;
      align-items: center;
       &:focus {
        outline: none;
      }
      
      .avatar_container {
        margin-right: 30px;
        margin-left:10px;

        .avatar_wrapper {
          min-width:80px;
          // margin-top: 5px;
          position: relative;
          display: flex;
          align-items: center;
          color:#fff;
          cursor: pointer;
          .user_avatar {

            width: 40px;
            height: 40px;
            vertical-align: middle;
            margin-right:8px;
          }
          .user_name{
              color:#fff;
          }
          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            // top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
  .bells{
    font-size: 24px;
    margin-right: 20px;
    color:#fff;
  }
  .member{
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding-left:30px;
    margin:5px 0;
    cursor: pointer;
    &::before{
      content:'';
      position: absolute;
      left:20px;
      top:5px;
      width:4px;
      height:4px;
      border-radius: 50%;
      background: #888;
    }
    span{
      color:red;
    }
  }
  /deep/ .el-popover__title{
    margin-bottom:10px;
  
  }
 
  </style>
